export const storypostPrivacy = {
  lastUpdated: 'June 25, 2026',
  title: 'Privacy Policy',
  intro: 'How Story Post handles photos, templates, exports, device data, and support requests.',
  sections: [
    {
      title: 'Overview',
      body: [
        'Story Post helps users turn their own photos into ready-made social story posts, carousel images, and photo templates.',
        'Your photos are processed locally on your device. Story Post does not upload your photos to our servers, does not store your photos on our servers, and does not use your photos for AI training.',
      ],
    },
    {
      title: 'Photos and User Content',
      body: [
        'When you select photos, the app uses them only to place them into templates, preview edits, apply layout changes, and export the final images on your device.',
        'Photo editing, cropping, template rendering, and export are designed to happen locally. We do not receive, view, sell, share, or train AI models on your photos.',
        'If you choose to save, export, or share finished images through your device or another app, that action is controlled by your device settings and the third-party app or platform you choose.',
      ],
    },
    {
      title: 'Information We May Process',
      body: [
        'The app may store local preferences such as selected templates, editing settings, export choices, language settings, or recent project data on your device.',
        'App stores, operating systems, crash reporting, analytics, billing, advertising, or support tools may process technical information such as device type, operating system, app version, crash logs, approximate usage events, purchase status, or advertising identifiers. These technical services do not require us to upload your photos.',
      ],
    },
    {
      title: 'How We Use Information',
      body: [
        'We use information to operate Story Post, provide templates, render exports, remember preferences, support purchases, fix bugs, improve app quality, prevent abuse, and respond to support requests.',
        'We do not sell personal information. We share information only with service providers or platforms when needed to operate the app, comply with law, process purchases, protect the service, or provide support.',
      ],
    },
    // {
    //   title: 'AI Training',
    //   body: [
    //     'Story Post does not use your photos, exported images, templates you create, or personal content to train AI models.',
    //     'The first version of Story Post is based on pre-designed templates and local editing. It does not perform AI photo recognition, AI story generation, or AI caption generation.',
    //   ],
    // },
    {
      title: 'Permissions',
      body: [
        'Story Post may request access to photos, media, storage, notifications, or similar device features so you can select photos, save exports, and use app features.',
        'You can review or change permissions in your device settings. If you deny a permission, some features may not work as expected.',
      ],
    },
    {
      title: 'Payments, Ads, and Analytics',
      body: [
        'If Story Post offers subscriptions, in-app purchases, ads, rewarded unlocks, analytics, or crash reporting, the relevant app store, payment provider, advertising network, analytics provider, or crash reporting provider may process information according to its own policies.',
        'Payment providers may process purchase information. We do not receive your full payment card details from app store billing.',
      ],
    },
    {
      title: 'Data Retention and Deletion',
      body: [
        'Local app data may remain on your device until you delete projects, clear app data, uninstall the app, or use an in-app reset or deletion feature if available.',
        'For privacy questions or deletion requests related to support communications or account-linked data, contact us at yuw558071@gmail.com. We may retain limited records when required for legal compliance, security, fraud prevention, refunds, dispute handling, or app store obligations.',
      ],
    },
    {
      title: 'Children Privacy',
      body: [
        'Story Post is intended for a general audience. We do not knowingly collect personal information from children in a way that requires parental consent. If you believe a child has provided personal information, please contact us.',
      ],
    },
    {
      title: 'Changes',
      body: [
        'We may update this Privacy Policy as Story Post changes. The latest version will be posted on this page with the updated date.',
      ],
    },
    {
      title: 'Contact',
      body: [
        'For privacy questions, contact us at yuw558071@gmail.com.',
      ],
    },
  ],
};

export const storypostTerms = {
  lastUpdated: 'June 25, 2026',
  title: 'Terms of Service',
  intro: 'The rules for using Story Post, templates, exports, purchases, and related 2xHappiness services.',
  sections: [
    {
      title: 'Acceptance of Terms',
      body: [
        'By downloading, accessing, or using Story Post, you agree to these Terms of Service. If you do not agree, please do not use the app.',
        'These terms apply to Story Post. Other 2xHappiness apps may have separate terms that match their own features.',
      ],
    },
    {
      title: 'Use of the App',
      body: [
        'Story Post is a photo story template tool that helps you create social posts from photos you choose on your device.',
        'You agree to use Story Post lawfully, responsibly, and in accordance with applicable app store rules, platform rules, and local laws.',
      ],
    },
    {
      title: 'Your Photos and Content',
      body: [
        'You keep ownership of the photos and personal content you select, edit, save, export, or share through Story Post.',
        'You are responsible for making sure you have the rights and permissions needed to use any photos, names, likenesses, text, or other content you add to a Story Post project.',
        'You may not use Story Post to create, export, or share content that is unlawful, infringing, harmful, abusive, deceptive, hateful, sexually exploitative, or otherwise violates the rights of others.',
      ],
    },
    {
      title: 'Local Processing',
      body: [
        'Story Post is designed so photo selection, template preview, editing, rendering, and export happen locally on your device.',
        'We do not upload your photos to our servers and do not use your photos for AI training.',
      ],
    },
    {
      title: 'Templates and App Materials',
      body: [
        'The app, templates, layouts, designs, text, stickers, fonts, code, logos, and related materials are owned by 2xHappiness or our licensors.',
        'You may use exported images for personal social sharing, subject to these terms and any rights that apply to your own photos and third-party content. These terms do not transfer ownership of the app, templates, or other 2xHappiness materials to you.',
      ],
    },
    // {
    //   title: 'Free and Paid Features',
    //   body: [
    //     'Story Post may offer free templates, Pro templates, watermark removal, high-resolution export, extra styles, subscriptions, one-time purchases, ads, or rewarded unlocks.',
    //     'Pricing, renewal, cancellation, refund, and access rules are shown at the time of purchase or display and may also be governed by the app store or payment provider.',
    //   ],
    // },
    {
      title: 'Exports and Sharing',
      body: [
        'Story Post may let you save exported images to your device or share them through system sharing to apps such as social platforms or messaging apps.',
        'We do not control third-party apps or platforms. Their upload, display, privacy, moderation, and account rules apply once you choose to share or post content outside Story Post.',
      ],
    },
    {
      title: 'Availability and Changes',
      body: [
        'We may update, change, pause, remove, or discontinue parts of Story Post at any time, including templates, export options, free limits, Pro features, or visual styles.',
        'We may also change these terms as the app evolves. Continued use of Story Post after changes means you accept the updated terms.',
      ],
    },
    {
      title: 'Disclaimers',
      body: [
        'Story Post is provided on an as-is and as-available basis. We do not promise that the app will always be available, error-free, compatible with every device, or accepted by every social platform.',
        'Template previews and exported images may vary depending on device model, operating system, display settings, photo quality, export size, platform compression, and third-party app behavior.',
      ],
    },
    {
      title: 'Limitation of Liability',
      body: [
        'To the maximum extent permitted by law, 2xHappiness is not liable for indirect, incidental, special, consequential, or punitive damages, or for loss of data, content, photos, exports, revenue, goodwill, or other intangible losses related to your use of Story Post.',
      ],
    },
    {
      title: 'Contact',
      body: [
        'Questions about these terms can be sent to yuw558071@gmail.com.',
      ],
    },
  ],
};
